import React from "react";
import { downArrow } from "../../assets/icons";
import { ImgIcon, Spinner } from "../../assets";
import { useModal } from "../../assets/useModal";
import EtaSelector from "../EtaSelector";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateShopOrder } from "../../actions/shop";
import { COLORS, COLLECTION, DELIVERY, CONFIRMED, DISPATCHED, READY, COMPLETED, REJECTED, PAID } from "../../constants";

export default function OrderStatusChanger({ order }) {

	const dispatch = useDispatch();
	const { openModal, setModal, closeModal } = useModal();
	const [open, setOpen] = useState(false);

	return <div className={`orderStatusChanger ${open ? "open" : ""}`}>

		<div
			className={`current text-center featureFont upperCase`}
			onClick={e => {
				setOpen(!open);
			}}
		>
			<div className={`overlay status-${order.status}-bg-color`} />
			<span className="status-text featureFont upperCase">
				{order.loading ? <Spinner
					size={35}
					color={`rgba(${COLORS[order.status].join(", ")}, 0.75)`}
				/> : order.status}
			</span>
			<div className="arrow" style={{ opacity: order.loading ? 0 : 1 }}>
				<ImgIcon src={downArrow} size={30} onClick={e => { }} />
			</div>
		</div>

		<div className={`options status-${order.status}-border-color`}>
			{[
				// Confirmed allowed if currently paid.
				(order.status === PAID) && CONFIRMED,
				// Dispatched allowed if order is delivery, and currently confirmed.
				(order.status === CONFIRMED && order.type === DELIVERY) && DISPATCHED,
				// Ready allowed if order is collection, and currently confirmed.
				(order.status === CONFIRMED && order.type === COLLECTION) && READY,
				// Completed allowed if dispatched/ready.
				[DISPATCHED, READY].includes(order.status) && COMPLETED,
				// Rejected allowed at any time.
				REJECTED,
			].filter(s => s).filter(option => option !== order.status).map(option => {
				return <div
					className="option bordered-top"
					key={option}
					onClick={e => {
						if (option === CONFIRMED) {
							setOpen(false);
							setModal(
								<section key={order.id} className="time-section">
									<h2>{(() => {
										switch (order.type) {
											case COLLECTION:
												return "When can they collect?";
											case DELIVERY:
												return "When will you deliver?";
											default:
												return "When will it be ready?"
										}
									})()}</h2>
									<EtaSelector
										value={order.eta}
										onChange={val => {
											if (!window.confirm("Are you sure? We will also update your customer.")) return;
											dispatch(updateShopOrder(order.id, { status: option, eta: val.format() }))
											closeModal();
											setModal(null);
										}}
									/>
								</section>
							);
							openModal();
						} else {
							if (!window.confirm("Are you sure? We will also update your customer.")) return;
							dispatch(updateShopOrder(order.id, { status: option }));
							setOpen(false);
						}
					}}
				>
					<div className={`icon status-${option}-bg-color`} />
					<span className="status-text featureFont upperCase">{option}</span>
				</div>
			})}
		</div>

	</div>
}